export const fromLogin = props => ({
  ...props,
  id: props.id.toString(),
});



// WEBPACK FOOTER //
// ./src/resources/app/normalizers.js